import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {TestService} from '../../../services/api/test.service';
import {TEST_VALIDATORS} from '../../../../constants/validators';

@Component({
  selector: 'app-test-create-dialog',
  templateUrl: './test-create-dialog.component.html',
  styleUrls: ['./test-create-dialog.component.css']
})
export class TestCreateDialogComponent implements OnInit {

  testForm = this.fb.group({
    name: ['', TEST_VALIDATORS.NAME],
    type: ['COMMON', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TestCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
    private testService: TestService,
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.testForm.valid) {
      this.testService.addTest({
        name: this.testForm.controls.name.value,
        type: this.testForm.controls.type.value,
      })
        .then(test => this.dialogRef.close(test));
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
